import { TextField, Typography, styled } from '@mui/material';

import Flex from 'ui/Flex/Flex';
import React from 'react';
import { useTranslation } from 'react-i18next';

const StyTextField = styled(TextField, { name: 'StyTextField' })({
    width: '220px',
});

type UserGroupNameSetterProps = {
    name: string;
    onNameChange: (arg: string) => void;
    helperText: string;
};

const UserGroupNameSetter = ({
    name,
    onNameChange,
    helperText,
}: UserGroupNameSetterProps): JSX.Element => {
    const { t } = useTranslation();

    return (
        <Flex direction="column" sx={{ p: 1, gap: 2 }}>
            <Typography variant="body1SemiBold">
                {t('adminSpace.createUserGroup.name')}
            </Typography>
            <StyTextField
                required
                value={name}
                onChange={(e) => onNameChange(e.target.value)}
                label={t('adminSpace.createUserGroup.name')}
                helperText={helperText}
            />
        </Flex>
    );
};

export default UserGroupNameSetter;
